import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getGuideDetailList } from '../../../../slices/thunks'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';

const GuideDetailListStatementModal = ({ data, isOpen, handleToggleModal, handlerUpdateGuideDetail }) => {

	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGuideDetails = createSelector(
		state => state.GuideDetails,
		guideDetail => ({
			guideDetailList: guideDetail.guideDetailList,
			isLoadingList: guideDetail.isLoadingList,
			isGuideDetailSuccess: guideDetail.isGuideDetailSuccess,
			error: guideDetail.error,
			isAdding: guideDetail.isAdding,
			isAdded: guideDetail.isAdded,
			isAddError: guideDetail.isAddError,
			isUpdating: guideDetail.isUpdating,
			isUpdated: guideDetail.isUpdated,
			isUpdateError: guideDetail.isUpdateError,
			isDeleting: guideDetail.isDeleting,
			isDeleted: guideDetail.isDeleted,
			isDeleteError: guideDetail.isDeleteError,
		})
	);

	const { guideDetailList, isLoadingList } = useSelector(selectorGuideDetails);

	const columns = useMemo(
		() => [
			{ header: 'Residuo', accessorKey: 'residue.name', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'amount', size: 'auto' },
			{
				header: 'Estado',
				accessorKey: 'status_guide_detail',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.status_guide_detail
					let bgColor = status.bgcolor;
					let txColor = status.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{row.original.status_guide_detail?.name
									? row.original.status_guide_detail.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{ 
			header: 'Guía', 
			accessorKey: 'guide.guide_number', 
			size: 'auto',
			Cell: ({ row }) => {
				const displayNumber = row.original.guide?.folio || row.original.guide?.guide_number || '-';
				return displayNumber;
			},
		},
			{
				header: 'Unidad de medida',
				accessorKey: 'unit_measurement.name',
				size: 'auto',
			},
			{
				header: 'Valor (CLP)',
				accessorKey: 'peso_value',
				size: 'auto',
			},
			{
				header: '¿Es orgánico?',
				accessorKey: 'organic',
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={row.original.organic}
						/>
					);
				},
			},
			{ header: 'Volumen', accessorKey: 'volumen', size: 'auto' },
		],
		[]
	);


	useEffect(() => {
		if (isOpen) {
			dispatch(getGuideDetailList({ statement_id: data._id }))
		}
	}, [isOpen])

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='lg'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>Residuos Declarados</ModalHeader>
				<ModalBody className=''>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<ODataGrid
							columns={columns}
							data={guideDetailList || []}
						/>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default GuideDetailListStatementModal;